/**
 * Layout breakpoints, as `[minWidth, maxWidth)` in px.
 *
 * Ported from the legacy `src/config/constants.js`. These must stay in step with
 * the `screens` in `tailwind.config.ts` (`tablet: 850px`, `lg: 1024px`) — the
 * layout switch is a JS decision (which component tree to render), so it can't be
 * expressed in CSS alone.
 */
export const SCREEN_SIZES = {
  mobile: [0, 850],
  tablet: [850, 1024],
  desktop: [1024, 1_000_000],
} as const;

export type ScreenMode = keyof typeof SCREEN_SIZES;

/** Widths below this render the mobile layout. */
export const MOBILE_MAX_WIDTH = SCREEN_SIZES.mobile[1];
